"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaPrepareNotification = exports.yupPrepareNotification = exports.schemaNotification = exports.yupNotification = exports.schemaPayloadNotification = exports.yupPayloadNotification = exports.schemaNotificationOnlineSGE2 = exports.yupNotificationOnlineSGE2 = void 0;
const yup = __importStar(require("yup"));
const enums_1 = require("../enums");
const usuario_1 = require("./usuario");
exports.yupNotificationOnlineSGE2 = yup.object({
    app_id: yup.string().required().default('').label('ID da aplicação'),
    headings: yup
        .object({
        en: yup.string().required().default('').label('Cabeçalho em inglês'),
    })
        .required()
        .label('Cabeçalhos da notificação'),
    contents: yup
        .object({
        en: yup.string().required().default('').label('Conteúdo em inglês'),
    })
        .required()
        .label('Conteúdo da notificação'),
    ios_badgeType: yup.string().required().default('').label('Tipo de badge para IOS'),
    ios_badgeCount: yup.number().required().default(1).label('Quantidade do badge para IOS'),
    content_available: yup.boolean().required().default(true).label('Conteúdo disponível'),
    data: yup
        .object({
        id: yup.string().label('ID do registro'),
        aluno: yup.string().label('Nome do aluno'),
        codigo: yup.string().label('Código do aluno'),
        codigo_aluno: yup.string().label('Código do aluno'),
        codigo_responsavel: yup.string().label('Código do responsável'),
        codigo_login_extra: yup.string().label('Código do login extra do aluno'),
        codigo_professor: yup.string().label('Código do professor'),
        codigo_usuario: yup.string().label('Código do usuário'),
        modulo: yup.string().label('Módulo (tela / view) no aplicativo'),
        titulo: yup.string().label('Título da notificação'),
        descricao: yup.string().label('Descrição da notificação'),
        remetente: yup.string().label('Remetente da notificação'),
        data: yup.string().label('Data da notificação'),
        data_notificacao: yup.string().label('Data do envio da notificação'),
        escola_id: yup.string().label('Código da escola'),
    })
        .required()
        .label('Payload da notificação'),
    include_player_ids: yup
        .array()
        .of(yup.string().required().label('ID do usuário'))
        .required()
        .label('Lista de destinatários da notificação'),
    send_after: yup.string(),
    delayed_option: yup.string(),
    delivery_time_of_day: yup.string(),
});
exports.schemaNotificationOnlineSGE2 = exports.yupNotificationOnlineSGE2.shape({});
exports.yupPayloadNotification = yup.object({
    id: yup.string().nullable().notRequired().optional().label('ID do registro'),
    idReal: yup.string().nullable().notRequired().optional().label('ID real do registro'),
    url: yup.string().nullable().notRequired().optional().label('URL para redirecionamento'),
    aluno: yup.string().nullable().notRequired().label('Nome do aluno'),
    codigoAluno: yup.string().nullable().notRequired().label('Código do aluno'),
    idAluno: yup.string().nullable().notRequired().label('ID do aluno'),
    codigoResponsavel: yup.string().nullable().notRequired().label('Código do responsável'),
    idResponsavel: yup.string().nullable().notRequired().label('ID do responsável'),
    codigoLoginExtra: yup.string().nullable().notRequired().label('Código do login extra do aluno'),
    idLoginExtra: yup.string().nullable().notRequired().label('ID do login extra do aluno'),
    codigoProfessor: yup.string().nullable().notRequired().label('Código do professor'),
    idProfessor: yup.string().nullable().notRequired().label('ID do professor'),
    codigoUsuario: yup.string().nullable().notRequired().label('Código do usuário'),
    idUsuario: yup.string().nullable().notRequired().label('ID do usuário'),
    modulo: yup.string().required().label('Módulo (tela / view) no aplicativo'),
    titulo: yup.string().required().label('Título da notificação'),
    descricao: yup.string().required().label('Descrição da notificação'),
    remetente: yup.string().required().label('Remetente da notificação'),
    data: yup.string().required().label('Data da notificação'),
    dataNotificacao: yup.string().required().label('Data do envio da notificação'),
    escolaId: yup.string().required().label('Código da escola'),
    icon: yup.string().nullable().notRequired().label('Icone da notificação'),
    image: yup.string().nullable().notRequired().label('Imagem da notificação'),
    fromId: yup.string().nullable().notRequired().label('Delta Id do remetente'),
    toId: yup.string().nullable().notRequired().label('Delta Id do destinatário'),
    channel: yup
        .mixed()
        .oneOf([null, undefined, ...Object.values(enums_1.ENotificationChannel)])
        .notRequired()
        .nullable()
        .default(enums_1.ENotificationChannel.academico)
        .label('Tipo de canal da notificação'),
});
exports.schemaPayloadNotification = exports.yupPayloadNotification.shape({});
exports.yupNotification = yup.object({
    pushTokens: yup.array().of(yup.string()).required().default([]).label('Destinatários'),
    title: yup.string().required().default('').label('Título da notificação'),
    body: yup.string().required().default('').label('Corpo da notificação'),
    imageUrl: yup.string().notRequired().nullable().label('URL da imagem'),
    image: yup.string().notRequired().nullable().label('URL de imagem para anexo'),
    icon: yup.string().notRequired().nullable().label('URL de icone'),
});
exports.schemaNotification = exports.yupNotification.shape({});
exports.yupPrepareNotification = yup
    .object({
    fromId: yup.string().required().label('Delta Id do usuário remetente'),
    toIds: yup.array().of(yup.string()).required().default([]).label('Delta Id dos destinatários'),
    to: yup
        .array()
        .of(usuario_1.yupUser.pick(['codigo', 'deltaId', 'escolaId', 'pushTokens', 'tipoUsuario', 'chatWith', 'id']))
        .required()
        .default([])
        .label('Delta Id dos destinatários'),
})
    .concat(exports.yupNotification.pick(['body', 'icon', 'image', 'title']));
exports.schemaPrepareNotification = exports.yupPrepareNotification.shape({});
